export const ACTUALIZE_CART_ERROR = {
  generic: 'generic',
  unauthorized: 'unauthorized',
  forbidden: 'forbidden',
  productNotFound: 'productNotFound',
  invalidProductId: 'invalidProductId',
} as const

export type ActualizeCartError = (typeof ACTUALIZE_CART_ERROR)[keyof typeof ACTUALIZE_CART_ERROR]
